/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: PageHelper.ts
 * Created by: Kevin
 * Create Date: 2022-12-12 15:49
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

// import {NavigationFailure} from "vue-router";
import AppConfig from "@/commons/AppConfig";
import ApiUrlBuilder from "@/commons/https/ApiUrlBuilder";
import HttpExecutor from "@/commons/https/HttpExecutor";
import HttpTokenProvider from "@/commons/https/HttpTokenProvider";
import Log from "@/commons/logs/Log";
import HttpRequestPost from "@/commons/https/HttpRequestPost";
import {HttpStatus} from "@/commons/https/HttpStatus";

export default class PageHelper {

    // ------------------------------------------------------------------------------------
    // singleton
    // ------------------------------------------------------------------------------------
    private static _instance: PageHelper;

    public static get Instance() {
        return this._instance || (this._instance = new this())
    }

    private constructor() {
    }

    /**
     * The `indexPage` variable holds the combined URL for the authentication site and the team service API.
     * It is constructed by concatenating the `authSiteURL` and `apiURLServiceTeam` properties
     * from the `AppConfig.Instance` object.
     */
    private indexPage = AppConfig.Instance.authSiteURL + AppConfig.Instance.apiURLServiceTeam

    /**
     * Initiates a logout process by sending a logout request to the server and redirects the user
     * based on the server response or a fallback index page if an error occurs.
     */
    /**
     * After a session has expired: drop what is left of it here, and land on the sign-in page with
     * this team filled in.
     *
     * The server's logout clears both session cookies and revokes the tokens. Its answer points on
     * to IDAM's logout, and this does NOT follow it. IDAM ignores team-site's return address and
     * sends the browser to the bare service host, and the console sends a team-less host to signup.
     * That is how "sign in again" ended on the signup page on kwstg01 (2026-10-14). An IDAM session
     * that is still live is welcome here: it makes signing back in one click.
     */
    public goToSignInAgain() {
        const target = AppConfig.Instance.signinURL(AppConfig.Instance.teamSlug);
        const req = new HttpRequestPost(ApiUrlBuilder.InstanceTeam,
            `/cld-service-teamsite/auth/logout`,
            {
                timeout: AppConfig.Instance.apiDefaultTimeout,
            }, new FormData()
        );
        HttpExecutor.Instance.execute(req, HttpTokenProvider.TeamService).catch((err) => {
            Log.error("error on clearing the expired session, cause: " + err);
        }).finally(() => {
            window.location.href = target;
        });
    }

    public goToLogout() {
        let req = new HttpRequestPost(ApiUrlBuilder.InstanceTeam,
            `/cld-service-teamsite/auth/logout`,
            {
                timeout: AppConfig.Instance.apiDefaultTimeout,
            }, new FormData()
        );
        HttpExecutor.Instance.execute(req, HttpTokenProvider.TeamService).then((res) => {
            if (res.status === HttpStatus.StatusOK && res.data?.redirectUrl) {
                Log.debug(">> going to logout, url: " + res.data.redirectUrl);
                window.location.href = HttpExecutor.resolveSafeRedirectUrl(res.data.redirectUrl);
            } else {
                window.location.href = this.indexPage
            }
        }).catch((err) => {
            Log.error("error on logout, cause: " + err);
            window.location.href = this.indexPage
        });
    }
}
// export type NavigationFailureCallback = (fail: NavigationFailure | void | null | undefined) => void;